import React, { useEffect } from "react";

import "./styles.scss";

const Recaptcha = props => {
  window.captchaCallback = (token) => {
    if(props.validEmail){
      props.callback()
    }
  }
  
  function loadRecaptchaWidget() {
  
    let resolve;
    const promise = new Promise(_resolve => {
      resolve = _resolve;
    });
  
    window.gCaptcha = resolve;
  
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
  
    document.head.appendChild(script);
  
    return promise;
  }

  useEffect(()=>{
    if(props.validEmail){
      loadRecaptchaWidget()
    }
  },[props.validEmail])

  if(props.validEmail){
    return (
   
      <button
        className={ "g-recaptcha " + props.classes }
        data-sitekey={"6Lef0uIUAAAAAIpODFlwgbwrZdkevrxCsMFaVFu4"}
        data-callback={"captchaCallback"}
        data-badge={'inline'}
      >
        {props.label}
      </button>
  );  
  }else{
    return (
   
      <button
      className={props.classes}
        disabled
      >
        {props.label}
      </button>
  );  
  }
  
};

module.exports.Recaptcha = Recaptcha;
